import { colors } from 'Constants/Colors';

export default {
  // Ocupa el espacio restante del contenedor flex (evita superposición y overflow)
  flex: 1,
  background: colors.BLUE_GRAY,
  minHeight: '100vh',
};
